export default {
  path: 'setting',
  name: '设置',
  icon: 'SetUpFilled',
  accessKey: '19',
  routes: [
    {
      path: 'base',
      component: '@/pages/setting/base',
      name: '基本信息',
      accessKey: '21',
    },
    {
      path: 'account',
      component: '@/pages/setting/account',
      name: '账户管理',
      accessKey: '20',
    },

    {
      path: 'role',
      component: '@/pages/setting/role',
      name: '角色管理',
      accessKey: '22',
    },

    {
      path: 'approve',
      component: '@/pages/setting/approve',
      name: '审批设置',
      accessKey: '23',
    },
    // {
    //   path: 'room',
    //   component: '@/pages/setting/room',
    //   name: '客房管理',
    //   accessKey: '26',
    // },
    {
      path: 'other',
      component: '@/pages/setting/other',
      name: '其他配置',
      accessKey: '25',
    },
    {
      path: 'log',
      component: '@/pages/setting/log',
      name: '操作日志',
      accessKey: '24',
    },
  ],
};
